// extracted by mini-css-extract-plugin
module.exports = {"link":"_3JcA-","root":"_1t0pg","bg":"qx-TX","label":"_38K1W","top":"-Ct6t","bottom":"_1yit3"};